export default __webpack_public_path__ + "static/website-hero-6b60cfa2318b85ff0da7753fdf2b475f.mp4";